<template>
  <div style="padding: 20px;">
    <!-- ===== 标签页切换 ===== -->
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="肺结节协诊趋势" name="trend">
        <!-- ===== 图表1：协诊趋势 ===== -->
        <el-card shadow="never" style="margin-top: 10px;">
          <div slot="header" class="clearfix">
            <span style="font-weight: bold; font-size: 16px;">肺结节协诊趋势</span>
            <el-row style="float: right;">
              <el-select v-model="trendType" style="width: 100px; margin-right: 10px;">
                <el-option label="按日" value="daily" />
                <el-option label="按月" value="monthly" />
              </el-select>
              <el-date-picker v-model="trendYear" type="year" placeholder="选择年份" value-format="yyyy" style="width: 130px;" />
              <el-date-picker v-if="trendType === 'daily'" v-model="trendMonth" type="month" placeholder="选择月份" value-format="yyyy-MM" style="width: 140px; margin-left: 5px;" />
              <el-button type="primary" style="margin-left: 10px;" @click="loadCodiagTrend">查询</el-button>
            </el-row>
          </div>
          <div ref="trendChart" style="width: 100%; height: 350px;"></div>
        </el-card>

        <!-- ===== 图表2：科室协诊分布 ===== -->
        <el-card shadow="never" style="margin-top: 20px;">
          <div slot="header" class="clearfix">
            <span style="font-weight: bold; font-size: 16px;">年度患者来源科室分布</span>
            <el-row style="float: right;">
              <el-date-picker v-model="deptYear" type="year" placeholder="选择年份" value-format="yyyy" style="width: 130px;" />
              <el-button type="primary" style="margin-left: 10px;" @click="loadCodiagByDept">查询</el-button>
            </el-row>
          </div>
          <div ref="deptChart" style="width: 100%; height: 400px;"></div>
        </el-card>

        <!-- ===== 图表3：高危患者分布 ===== -->
        <el-card shadow="never" style="margin-top: 20px; margin-bottom: 20px;">
          <div slot="header" class="clearfix">
            <span style="font-weight: bold; font-size: 16px;">管理患者分布</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="8">
              <div ref="ageChart" style="width: 100%; height: 350px;"></div>
            </el-col>
            <el-col :span="8">
              <div ref="genderChart" style="width: 100%; height: 350px;"></div>
            </el-col>
            <el-col :span="8">
              <div ref="tagChart" style="width: 100%; height: 350px;"></div>
            </el-col>
          </el-row>
        </el-card>
      </el-tab-pane>

      <el-tab-pane label="协诊导出" name="export">
        <el-card shadow="never" style="margin-top: 10px;">
          <div slot="header" class="clearfix">
            <span style="font-weight: bold; font-size: 16px;">肺结节协诊导出</span>
          </div>

          <el-form :model="exportForm" label-width="100px" style="max-width: 500px; padding: 20px;">
            <el-form-item label="查询方式">
              <el-radio-group v-model="exportForm.type">
                <el-radio label="month">按月</el-radio>
                <el-radio label="year">按年</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="年份">
              <el-date-picker v-model="exportForm.year" type="year" placeholder="选择年份"
                value-format="yyyy" style="width: 200px;" />
            </el-form-item>

            <el-form-item label="月份" v-if="exportForm.type === 'month'">
              <el-date-picker v-model="exportForm.month" type="month" placeholder="选择月份"
                value-format="yyyy-MM" style="width: 200px;" />
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="handleExport" :loading="exportLoading" size="large">
                {{ exportLoading ? '导出中...' : '导出 Excel' }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { getCodiagTrend, getCodiagByDept, getPatientDistribution, exportCodiagDetailExcel } from "@/api/health/LungStatistics";

export default {
  data() {
    const now = new Date();
    const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    return {
      activeTab: 'trend',

      // ---- 趋势页 ----
      trendType: 'daily',
      trendYear: String(lastMonth.getFullYear()),
      trendMonth: lastMonth.getFullYear() + '-' + String(lastMonth.getMonth() + 1).padStart(2, '0'),
      deptYear: String(now.getFullYear()),
      trendChartInstance: null,
      deptChartInstance: null,
      ageChartInstance: null,
      genderChartInstance: null,
      tagChartInstance: null,
      exportLoading: false,

      // ---- 导出页 ----
      exportForm: {
        type: 'month',
        year: String(lastMonth.getFullYear()),
        month: lastMonth.getFullYear() + '-' + String(lastMonth.getMonth() + 1).padStart(2, '0'),
      },
      exportLoading: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.loadCodiagTrend();
      this.loadCodiagByDept();
      this.loadPatientDistribution();
    });
  },
  beforeDestroy() {
    [this.trendChartInstance, this.deptChartInstance, this.ageChartInstance, this.genderChartInstance, this.tagChartInstance].forEach(ch => {
      if (ch) { ch.dispose(); ch = null; }
    });
  },
  methods: {
    handleTabClick(tab) {
      if (tab.name === 'trend') {
        this.$nextTick(() => {
          if (this.trendChartInstance) this.trendChartInstance.resize();
          if (this.deptChartInstance) this.deptChartInstance.resize();
          if (this.ageChartInstance) this.ageChartInstance.resize();
          if (this.genderChartInstance) this.genderChartInstance.resize();
          if (this.tagChartInstance) this.tagChartInstance.resize();
        });
      }
    },

    // ---- 协诊趋势 ----
    async loadCodiagTrend() {
      const params = { type: this.trendType };
      if (this.trendYear) params.year = parseInt(this.trendYear);
      if (this.trendType === 'daily' && this.trendMonth) {
        const parts = this.trendMonth.split('-');
        params.year = parseInt(parts[0]);
        params.month = parseInt(parts[1]);
      }
      try {
        const res = await getCodiagTrend(params);
        if (res.msg === 'success') {
          this.renderTrendChart(res.codiagData || [], res.highRiskData || []);
        }
      } catch (e) { console.error(e); }
    },

    // ---- 年度科室协诊分布 ----
    async loadCodiagByDept() {
      const params = {};
      if (this.deptYear) params.year = parseInt(this.deptYear);
      try {
        const res = await getCodiagByDept(params);
        if (res.msg === 'success') {
          this.renderDeptChart(res.data || []);
        }
      } catch (e) { console.error(e); }
    },

    // ---- 管理患者年龄/性别/标签分布 ----
    async loadPatientDistribution() {
      try {
        const res = await getPatientDistribution();
        if (res.msg === 'success') {
          this.renderAgeChart(res.ageDist || []);
          this.renderGenderChart(res.genderDist || []);
          this.renderTagChart(res.tagDist || []);
        }
      } catch (e) { console.error(e); }
    },

    // ---- 导出 ----
    async handleExport() {
      if (!this.exportForm.year) { this.$message.warning('请选择年份'); return; }
      if (this.exportForm.type === 'month' && !this.exportForm.month) { this.$message.warning('请选择月份'); return; }

      const parts = this.exportForm.type === 'month' ? this.exportForm.month.split('-') : [this.exportForm.year, null];
      const year = parseInt(parts[0]);
      const month = parts[1] ? parseInt(parts[1]) : null;

      this.exportLoading = true;
      try {
        const params = { year };
        if (month) params.month = month;
        const res = await exportCodiagDetailExcel(params);
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const timeSuffix = month ? year + '年' + month + '月' : year + '年';
        a.download = '肺结节协诊完整导出_' + timeSuffix + '.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.$message.success('导出成功');
      } catch (e) {
        console.error(e);
        this.$message.error('导出失败');
      } finally {
        this.exportLoading = false;
      }
    },

    // ---- 图表渲染 ----
    renderTrendChart(codiagData, highRiskData) {
      if (!this.trendChartInstance) {
        this.trendChartInstance = echarts.init(this.$refs.trendChart);
      }
      const dateSet = new Set();
      codiagData.forEach(d => dateSet.add(d.date_key));
      highRiskData.forEach(d => dateSet.add(d.date_key));
      const keys = Array.from(dateSet).sort();
      const codiagMap = {};
      const riskMap = {};
      codiagData.forEach(d => { codiagMap[d.date_key] = d.count; });
      highRiskData.forEach(d => { riskMap[d.date_key] = d.count; });
      const codiagValues = keys.map(k => codiagMap[k] ? parseInt(codiagMap[k]) : 0);
      const riskValues = keys.map(k => riskMap[k] ? parseInt(riskMap[k]) : 0);
      this.trendChartInstance.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: ['协诊人数', '高危发现人数'], bottom: 0 },
        grid: { left: '5%', right: '5%', bottom: '20%', containLabel: true },
        xAxis: { type: 'category', data: keys, axisLabel: { rotate: 45, fontSize: 11 } },
        yAxis: { type: 'value', minInterval: 1 },
        series: [{
          name: '协诊人数', type: 'bar', data: codiagValues,
          itemStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#409EFF' }, { offset: 1, color: '#7ec2f7' }]) },
          barMaxWidth: 30,
        }, {
          name: '高危发现人数', type: 'bar', data: riskValues,
          itemStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#F56C6C' }, { offset: 1, color: '#faa0a0' }]) },
          barMaxWidth: 30,
        }]
      });
      this.trendChartInstance.resize();
    },
    renderDeptChart(data) {
      if (!this.deptChartInstance) {
        this.deptChartInstance = echarts.init(this.$refs.deptChart);
      }
      const names = data.map(d => d.dept_name || '未知');
      const values = data.map(d => d.count);
      this.deptChartInstance.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: '30%', right: '5%', containLabel: true },
        xAxis: { type: 'value', minInterval: 1 },
        yAxis: { type: 'category', data: names, axisLabel: { fontSize: 11 } },
        series: [{
          type: 'bar', data: values,
          itemStyle: { color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
            { offset: 0, color: '#67C23A' }, { offset: 1, color: '#a8e06c' }]) },
          barMaxWidth: 30,
        }]
      });
      this.deptChartInstance.resize();
    },
    renderAgeChart(data) {
      if (!this.ageChartInstance) {
        this.ageChartInstance = echarts.init(this.$refs.ageChart);
      }
      const ageOrder = ['45岁以下', '45-54岁', '55-64岁', '65-74岁', '75-84岁', '85岁及以上'];
      const sorted = ageOrder.map(k => {
        const found = data.find(d => d.age_range === k);
        return { name: k, value: found ? parseInt(found.count) : 0 };
      }).filter(d => d.value > 0);
      this.ageChartInstance.setOption({
        title: { text: '年龄分布', left: 'center', textStyle: { fontSize: 14 } },
        tooltip: { trigger: 'item', formatter: '{b}: {c}人 ({d}%)' },
        legend: { bottom: 0, textStyle: { fontSize: 11 } },
        color: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399', '#B37FEB'],
        series: [{ type: 'pie', radius: ['35%', '60%'], center: ['50%', '45%'], label: { show: false }, data: sorted.length ? sorted : [{ name: '暂无数据', value: 1 }] }]
      });
      this.ageChartInstance.resize();
    },
    renderGenderChart(data) {
      if (!this.genderChartInstance) {
        this.genderChartInstance = echarts.init(this.$refs.genderChart);
      }
      const genderMap = { '1': '男', '2': '女', '0': '未知' };
      const chartData = data.map(d => ({ name: genderMap[d.gender] || '未知', value: parseInt(d.count) }));
      this.genderChartInstance.setOption({
        title: { text: '性别分布', left: 'center', textStyle: { fontSize: 14 } },
        tooltip: { trigger: 'item', formatter: '{b}: {c}人 ({d}%)' },
        legend: { bottom: 0, textStyle: { fontSize: 11 } },
        color: ['#409EFF', '#F56C6C', '#909399'],
        series: [{ type: 'pie', radius: ['35%', '60%'], center: ['50%', '45%'], label: { show: true, formatter: '{b}\n{d}%' }, data: chartData.length ? chartData : [{ name: '暂无数据', value: 1 }] }]
      });
      this.genderChartInstance.resize();
    },
    renderTagChart(data) {
      if (!this.tagChartInstance) {
        this.tagChartInstance = echarts.init(this.$refs.tagChart);
      }
      const chartData = data.map(d => ({ name: d.tag_name, value: parseInt(d.count) }));
      this.tagChartInstance.setOption({
        title: { text: '管理标签分布', left: 'center', textStyle: { fontSize: 14 } },
        tooltip: { trigger: 'item', formatter: '{b}: {c}人 ({d}%)' },
        legend: { bottom: 0, textStyle: { fontSize: 11 } },
        color: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399', '#B37FEB', '#36CBCA', '#FF8C00'],
        series: [{ type: 'pie', radius: ['35%', '60%'], center: ['50%', '45%'], label: { show: true, formatter: '{b}\n{d}%' }, data: chartData.length ? chartData : [{ name: '暂无数据', value: 1 }] }]
      });
      this.tagChartInstance.resize();
    },
  }
};
</script>

<style scoped>
.el-card >>> .el-card__header {
  padding: 12px 20px;
}
.el-divider {
  margin: 20px 0;
}
</style>
